import { CheckCircleOutlined, InboxOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, Input, Row, Select, Space, Upload, notification } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllAcoes } from "../../../api/acoes";
import { postCreateClientes } from '../../../api/clientes';
import InputNormal from "../../../components/InputNormal";
import { useAuth } from "../../../contexts/AuthContext";
import { useLoading } from "../../../contexts/LoadingContext";
import { ClienteEnums } from '../../../enums/ClienteEnums';

const { Option } = Select;

const formItemLayout = {
    labelCol: { flex: '0 0 25px' }, // Ajuste a largura das labels conforme necessário
    wrapperCol: { flex: '1' },
};

type acoesType = {
    id: string;
    nome_acao: string;
}

export default function FormCliente() {
    const [acoes, setAcoes] = useState<acoesType[]>([]);
    const { setLoading } = useLoading();
    const [btnLoading, setBtnLoading] = useState(false); // Loading do botão de cadastro
    const types = ["application/pdf", "application/vnd.openxmlformats-officedocument.wordprocessingm", "application/msword"];
    const { user } = useAuth();
    let navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        const allAcoes = getAllAcoes();
        allAcoes.then((res) => {
            setAcoes(res.data)
            setLoading(false);
        }
        );
    }, []);

    const normFile = (e: any) => {
        console.log('Upload event:', e);
        if (Array.isArray(e)) {
            return e;
        }
        return e?.fileList;
    };

    const validateMessages = {
        required: '${label} é obrigatório!',
        types: {
            email: '${label} não é um email válido, verifique se você digitou @gmail por exemplo!',
            number: '${label} is not a valid number!',
        },
    };


    const onFinish = async (values: any) => {
        setBtnLoading(true);
        if (values) {
            const sanitizedValues = Object.fromEntries(
                Object.entries(values).map(([key, value]) => [key, value === undefined ? '' : value])
            );

            const formValues = { ...sanitizedValues, userId: user.id, statusClienteId: ClienteEnums.ABERTO };

            try {
                const res = await postCreateClientes(formValues);
                if (res.status === 201) {
                    notification.success({
                        message: 'Sucesso!',
                        description: 'Cliente cadastrado com sucesso!',
                    });
                    navigate(`/demandas/geral/cliente/${res.data.cliente.id}`);
                }
            } catch (error) {
                console.error('Erro ao cadastrar cliente:', error);
            } finally {
                setBtnLoading(false);
            }
        }
    };


    return (
        <div>
            <Card title="Cadastrar cliente">
                <Form
                    name="wrap"
                    onFinish={onFinish}
                    labelCol={formItemLayout.labelCol}
                    labelAlign="left"
                    layout="vertical" // Usando layout "vertical" para colocar os labels acima dos campos
                    colon={false}
                    validateMessages={validateMessages}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <InputNormal label="Nome:" name="nome" rules={[{ required: true, message: 'Please input your phone number!' }]} />
                        </Col>
                        <Col span={12}>
                            <InputNormal label="Endereço:" name="endereco" rules={[{ required: true, message: 'Please input your phone number!' }]} />
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={6}>
                            <InputNormal label="RG:" name="rg" rules={[{ required: true, message: 'Please input your phone number!' }]} />
                        </Col>
                        <Col span={6}>
                            <InputNormal label="CPF:" name="cpf" rules={[{ required: true, message: 'Please input your phone number!' }]} />
                        </Col>
                        <Col span={6}>
                            <InputNormal label="Email:" name="email" hasFeedback rules={[{ required: false, type: 'email' }]} />
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                name="telefone"
                                label="Telefone:"
                                rules={[{ required: false, message: 'Please input your phone number!' }]
                                }
                            >
                                <Input
                                    // addonBefore={prefixSelector}
                                    style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={8}>
                            <Form.Item
                                name="nacionalidade"
                                label="Nacionalidade"
                                rules={[{ required: true, message: 'Por favor, selecione um país!' }]}
                            >
                                <Select placeholder="Por favor, selecione um país!">
                                    <Option value="brasileira">Brasileira</Option>
                                    <Option value="outro">Outro</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name="estado_civil"
                                label="Estado Civil"
                                rules={[{ required: true, message: 'Por favor, selecione um estado civil!' }]}
                            >
                                <Select placeholder="Por favor, selecione um estado civil!">
                                    <Option value="solteiro">Solteiro(a)</Option>
                                    <Option value="casado">Casado(a)</Option>
                                    <Option value="separado">Separado(a)</Option>
                                    <Option value="divorciado">Divorciado(a)</Option>
                                    <Option value="viuvo">Viuvo(a)</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name="acoes"
                                label="Ação:"
                                rules={[{ required: true, message: 'Por favor, selecione o tipo da ação!', type: 'array' }]}
                            >
                                <Select mode="multiple" placeholder="Por favor, selecione o tipo da ação!">
                                    {acoes.map((acao) => (
                                        <Option key={acao.id} value={acao.id}>
                                            {acao.nome_acao}
                                        </Option>
                                    ))}

                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item name={'anotacoes'} label="Anotações:" >
                                <Input.TextArea />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="files"
                                label="Upload"
                                valuePropName="fileList"
                                getValueFromEvent={normFile}
                                extra="No momento o sistema aceita apenas arquivos no formato (.pdf)"
                            >
                                <Upload.Dragger multiple={true} accept=".pdf" beforeUpload={(file) => {
                                    if (!types.includes(file.type)) {
                                        notification.error({ message: `${file.name} No momento o sistema aceita apenas arquivos no formato (.pdf)` });
                                        return false;
                                    } else {
                                        return false;
                                    }
                                }} action={() => {
                                    notification.error({ message: 'No momento o sistema aceita apenas arquivos no formato (.pdf)' });
                                    return '';
                                }} maxCount={5} showUploadList={true}>
                                    <p className="ant-upload-drag-icon">
                                        <InboxOutlined />
                                    </p>
                                    <p className="ant-upload-text">Arraste e solte o arquivo aqui ou clique</p>
                                    <p className="ant-upload-hint">Aceita um ou mais arquivos</p>
                                </Upload.Dragger>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row style={{ justifyContent: 'flex-end' }}>
                        <Col>
                            <Space>
                                <Form.Item>
                                    <Button type="primary" onClick={() => navigate(-1)}>
                                        VOLTAR
                                    </Button>
                                </Form.Item>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit" loading={btnLoading} icon={<CheckCircleOutlined />}>
                                        CADASTRAR
                                    </Button>
                                </Form.Item>
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    )
}
